import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/admitted`;

export const getAdmittedPatients = async (cipId = null, locationId = null, memberType = null) => {
  try {
    const params = {};
    if (cipId) params.cipId = cipId;
    if (locationId) params.locationId = locationId;
    if (memberType) params.memberType = memberType;

    const response = await axios.get(API_URL, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching admitted patients:", error);
    throw error;
  }
};
